<div class="admin-unconfirm-container" fxLayout="column">
  <div class="title">لطفا دلیل را در کادر زیر وارد کنید.</div>
  <div class="form">
    <mat-form-field appearance="outline" fxFlex="100">
      <textarea
        placeholder="حد اقل ۵ کاراکتر"
        #reason
        matInput
        id=""
        cols="30"
        rows="10"
      ></textarea>
    </mat-form-field>
  </div>
</div>
<div class="action" mat-dialog-actions>
  <button
    mat-button
    (click)="unconfirm(reason.value)"
    [disabled]="reason.value.length < 5"
    mat-dialog-close
    color="warn"
  >
    <span>تایید خطا</span>
    <jam-icon name="close"></jam-icon>
  </button>

  <button mat-button mat-dialog-close color="primary">
    <span>بستن</span>
    <jam-icon name="close"></jam-icon>
  </button>
</div>
